import { authActionTypes } from "./auth.types"

// SESSION
export const checkUserSession = () => ({
    type: authActionTypes.CHECK_USER_SESSION
})
export const updateSessionStatus = (status) => ({
    type: authActionTypes.UPDATE_SESSION_STATUS,
    payload: status,
})

// SIGN UP: EMAIL
export const signUpEmail = userCredentials => ({
    type: authActionTypes.SIGN_UP_EMAIL_START,
    payload: userCredentials
})
// SIGN UP: SUCCESS
export const signUpSuccess = ({ user }) => ({
    type: authActionTypes.SIGN_UP_SUCCESS,
    payload: { user }
})
// SIGN UP: FAILURE
export const signUpFailure = error => ({
    type: authActionTypes.SIGN_UP_FAILURE,
    payload: error
})

// SIGN IN: EMAIL / GOOGLE / GITHUB
export const signInEmail = emailAndPassword => ({
    type: authActionTypes.SIGN_IN_EMAIL_START,
    payload: emailAndPassword
})
export const signInGoogle = () => ({
    type: authActionTypes.SIGN_IN_GOOGLE_START
})
export const signInGithub = () => ({
    type: authActionTypes.SIGN_IN_GITHUB_START
})
export const signInMicrosoft = () => ({
    type: authActionTypes.SIGN_IN_MICROSOFT_START
})
// SIGN IN: SUCCESS
export const signInSuccess = user => ({
    type: authActionTypes.SIGN_IN_SUCCESS,
    payload: user
})
// SIGN IN: FAILURE
export const signInFailure = error => ({
    type: authActionTypes.SIGN_IN_FAILURE,
    payload: error
})

// SIGN OUT
export const signOut = () => ({
    type: authActionTypes.SIGN_OUT_START
})
export const signOutSuccess = () => ({
    type: authActionTypes.SIGN_OUT_SUCCESS
})
export const signOutFailure = error => ({
    type: authActionTypes.SIGN_OUT_FAILURE,
    payload: error
})

// FORGOT PASSWORD
export const forgotPassword = ({ email, redirectTo }) => ({
    type: authActionTypes.FORGOT_PASSWORD_START,
    payload: { email, redirectTo },
})
export const forgotPasswordSuccess = () => ({
    type: authActionTypes.FORGOT_PASSWORD_SUCCESS,
})
export const forgotPasswordFailure = error => ({
    type: authActionTypes.FORGOT_PASSWORD_FAILURE,
    payload: error,
})

// RESET PASSWORD
export const resetPassword = ({ newPassword, token }) => ({
    type: authActionTypes.RESET_PASSWORD_START,
    payload: { newPassword, token },
})
export const resetPasswordSuccess = () => ({
    type: authActionTypes.RESET_PASSWORD_SUCCESS,
})
export const resetPasswordFailure = error => ({
    type: authActionTypes.RESET_PASSWORD_FAILURE,
    payload: error,
})

export const clearAuthErrors = () => ({
    type: authActionTypes.CLEAR_AUTH_ERRORS
})
